import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import Footer from '@/components/feature/Footer';
import ReportsTab from './components/ReportsTab';
import UsersTab from './components/UsersTab';
import logoYonyonHeader from '@/assets/logo-yonyon-header-300x100.png';

type Tab = 'reports' | 'users';

export default function AdminPage() {
  const { user } = useAuth();
  const [tab, setTab] = useState<Tab>('reports');

  const canAccess = !!user && (user.isAdmin || user.isModerator);

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <header className="sticky top-0 z-40 bg-white/95 backdrop-blur border-b border-background-200">
        <div className="px-4 md:px-8 h-16 flex items-center justify-between gap-4">
          <div className="flex items-center justify-between w-full">
            <Link
              to="/"
              className="flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium text-foreground-600 hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-arrow-left-line text-base"></i>
              Retour
            </Link>

            <Link
              to="/"
              className="flex items-center cursor-pointer bg-white rounded-lg px-2 py-1"
            >
              <img
                src={logoYonyonHeader}
                alt="Yonyon"
                className="h-14 w-auto"
              />
            </Link>
          </div>
        </div>
      </header>

      <main className="flex-1 w-full px-4 md:px-8 py-6 md:py-8">
        <div className="max-w-3xl mx-auto">
          {/* Header */}
          <div className="flex items-center gap-3">
            <span className="w-12 h-12 rounded-full bg-primary-500 text-white flex items-center justify-center text-lg font-bold">
              <i className="ri-shield-check-line text-xl"></i>
            </span>
            <div>
              <h1 className="font-heading text-xl md:text-2xl font-semibold text-foreground-950">
                Administration
              </h1>
              <p className="text-sm text-foreground-500">
                Modération des signalements et gestion des utilisateurs
              </p>
            </div>
          </div>

          {!canAccess ? (
            <div className="mt-8 bg-white border border-background-200 rounded-lg p-10 text-center">
              <div className="w-14 h-14 mx-auto rounded-full bg-background-100 flex items-center justify-center text-foreground-400">
                <i className="ri-lock-line text-2xl"></i>
              </div>
              <h2 className="mt-4 font-heading text-lg font-semibold text-foreground-950">
                Accès réservé
              </h2>
              <p className="mt-1 text-sm text-foreground-500 max-w-xs mx-auto">
                Seuls les administrateurs et modérateurs peuvent accéder à cet espace.
              </p>
              <Link
                to="/"
                className="mt-5 inline-block px-4 py-2.5 rounded-md bg-primary-500 text-white text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                Retour à l'accueil
              </Link>
            </div>
          ) : (
            <>
              {/* Tabs */}
              <div className="mt-6 inline-flex rounded-full bg-background-100 p-1">
                <button
                  type="button"
                  onClick={() => setTab('reports')}
                  className={`px-5 py-2 rounded-full text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap ${tab === 'reports'
                    ? 'bg-white text-foreground-950'
                    : 'text-foreground-500 hover:text-foreground-700'
                    }`}
                >
                  Signalements
                </button>
                <button
                  type="button"
                  onClick={() => setTab('users')}
                  className={`px-5 py-2 rounded-full text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap ${tab === 'users'
                    ? 'bg-white text-foreground-950'
                    : 'text-foreground-500 hover:text-foreground-700'
                    }`}
                >
                  Utilisateurs
                </button>
              </div>

              <div className="mt-6">
                {tab === 'reports' ? <ReportsTab /> : <UsersTab />}
              </div>
            </>
          )}
        </div>
      </main>

      <Footer />
    </div>
  );
}